import { combineReducers } from "redux";
import {
  PAYMENT_METHODS_LOAD,
  PAYMENT_METHODS_CLEAR,
  PAYMENT_METHODS_ERROR,
  SET_SELECTED_PAYMENT_METHOD,
} from "./constant";

function methods(state = [], action) {
  switch (action.type) {
    case PAYMENT_METHODS_LOAD:
      return action.paymentMethods;
    case PAYMENT_METHODS_CLEAR:
      return [];
    default:
      return state;
  }
}

function selectedMethod(state = {}, action) {
  switch (action.type) {
    case SET_SELECTED_PAYMENT_METHOD:
      return action.method;
    default:
      return state;
  }
}

function errorMessage(state = "", action) {
  switch (action.type) {
    case PAYMENT_METHODS_ERROR:
      return action.message;
    default:
      return state;
  }
}

export default combineReducers({ methods, errorMessage, selectedMethod });
